import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: ', ';\n'], ['\n  display: ', ';\n']);

import styled from 'styled-components';

var StatelessSelectWrapper = styled.div(_templateObject, function (props) {
  return props.shouldFitContainer ? 'block' : 'inline-block';
});

StatelessSelectWrapper.displayName = 'SingleSelectStatelessSelectWrapper';

export default StatelessSelectWrapper;